/**
 * Service worker registration with update-prompt support.
 * Call once from main.jsx / App.jsx.
 */

export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  if (window.location.hostname === 'localhost') return;  // skip in dev

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => {
        // Detect when a new SW version is waiting
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version available — could show a toast prompting reload
              window.dispatchEvent(new CustomEvent('snt:sw-update-available'));
            }
          });
        });

        // Check for updates every 30 min
        setInterval(() => { reg.update().catch(() => {}); }, 1800000);
      })
      .catch(err => console.warn('SW registration failed:', err));

    // Handle messages from SW (e.g., from skip-waiting requests)
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.location.reload();
    });
  });
}
